import { useMemo } from "react";
import { useSessionContext } from "@/contexts/SessionContext";

export function useSessionBranch() {
  const ctx = useSessionContext();
  return useMemo(
    () => ({
      branchId: ctx.session.order.branchId,
      branchName: ctx.branchName,
      isOpen: ctx.session.order.isOpen,
      isBusy: ctx.session.order.isBusy,
      reason: ctx.session.order.branchStatusReason,
      branchAsapAllowed: ctx.session.order.branchAsapAllowed,
      branchScheduleAllowed: ctx.session.order.branchScheduleAllowed,
      setBranch: ctx.setBranch,
      setBranchStatus: ctx.setBranchStatus,
    }),
    [ctx.session.order.branchId, ctx.branchName, ctx.session.order.isOpen, ctx.session.order.isBusy, ctx.session.order.branchStatusReason, ctx.session.order.branchAsapAllowed, ctx.session.order.branchScheduleAllowed, ctx.setBranch, ctx.setBranchStatus]
  );
}
